import React from "react"
import { Text } from "../../../vanilla"

export const PrivacyPolicyLink = () => (
  <Text variant="text2" marginBottom="4px">
    To view our Privacy & Cookie Policy please{' '}
    <Text
      as="a"
      variant="unstyled"
      color="accent5"
      href="/privacy-policy"
      target="_blank"
      textDecoration="underline"
      fontSize="xs"
    >
      click here
    </Text>
  </Text>
)